module.exports = __webpack_public_path__ + "static/media/girl2.54faf56c.svg";